
/**
 * 수강신청 상태
 */
export type GetEnrollment200Status = typeof GetEnrollment200Status[keyof typeof GetEnrollment200Status];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEnrollment200Status = {
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  SUSPENDED: 'SUSPENDED',
  EXPIRED: 'EXPIRED',
} as const;
